module.exports = "<th>\n  <span ng-if=\"::categoryIs('suburban')\">Год постройки дома</span>\n  <span ng-if=\"::!categoryIs('suburban')\">Год постройки</span>\n</th>\n<td>\n  <cian-serp-range source=\"filter.house_year\"\n         range-min=\"1900\"\n         range-max=\"9999\"\n         ng-model-options=\"{updateOn: 'blur'}\"\n  ></cian-serp-range>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/house_year.html
// module id = 346
// module chunks = 0